import React from "react";
import CallToAction from "../partials/cta";
import ErrorMessage from "../partials/error";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Alert, Box, Typography, Grid } from "@mui/material";
import { Card, CardContent } from "@mui/material";

function DedupeForm({
  classes: { containerButton, formGroup },
  errorMessage = {},
  errors,
  form = {},
  isFormSubmitted,
  modal,
  onSubmit,
  orderDetails = null,
  result = null,
}) {
  return (
    <Box
      p={1}
      sx={{
        maxHeight: 520, // or any height you prefer
        overflowY: "auto",
      }}
    >
      <Box direction="column">
        <>
          <Card
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 1,
              pt: 0,
              m: 0,
              pb: 0,
              boxShadow: "0 6px 24px #0000001a, 0 1.5px 4px #0000000f",
              transition: "box-shadow .2s",
            }}
          >
            <CardContent sx={{ p: 1 }}>
              <Box className={formGroup} textAlign={"left"}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Proposal Number:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      <strong>{orderDetails?.proposalno}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box className={formGroup} textAlign={"left"}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Customer Name:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      <strong>{`${result?.givenName} ${result?.surName}`}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box className={formGroup} textAlign={"left"}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Date of Birth:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      <strong>{result?.clientDOB ?? "NA"}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box className={formGroup} textAlign={"left"}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">PAN:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      <strong>{result?.description ?? "NA"}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box className={formGroup} textAlign={"left"}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Father's Name:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      <strong>{`${result?.fatherGivenName} ${result?.fatherSurName}`}</strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              <Box className={formGroup} textAlign={"left"}>
                <Grid container spacing={1}>
                  <Grid item xs={6} variant="subtitle1" textAlign={"left"}>
                    <Typography variant="caption">Profile Match:</Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="caption">
                      <strong>
                        {result?.weightage >= 100 ? 100 : result?.weightage}%
                      </strong>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>

          <Box mt={2}>
            <Alert icon={false} severity="warning" sx={{ textAlign: "left" }}>
              <Typography variant="caption">
                <b>Note:</b> Please review the customer details provided above
                and take the necessary action accordingly.
              </Typography>
            </Alert>
          </Box>
        </>
      </Box>

      <ErrorMessage errors={errors} modal={modal} />

      <Box
        className={containerButton}
        justifyContent="center"
        alignContent="center"
      >
        <>
          <Box mt={1}>
            <CallToAction
              buttonType={"click"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={false}
              isFormSubmitted={isFormSubmitted}
              text={"Verify & Proceed"}
              handleClick={() => onSubmit(1)}
            />
          </Box>

          <Box mt={1}>
            <CallToAction
              buttonType={"click"}
              errorMessage={errorMessage}
              form={form}
              isDisabled={false}
              isFormSubmitted={isFormSubmitted}
              text={"INCORRECT DETAILS"}
              handleClick={() => onSubmit(0)}
              color={"error"}
            />
          </Box>
        </>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(DedupeForm);
